import {
  SET_TAB,
  SET_NAVIGATION_ERROR,
  INC_IN_CONTENT_VIDEOS_PRESENT,
  DEC_IN_CONTENT_VIDEOS_PRESENT,
  INC_IN_CONTENT_VIDEOS_VISIBLE,
  DEC_IN_CONTENT_VIDEOS_VISIBLE,
} from 'app/models/ui/call/constants';

export const setTab = payload => ({
  type: SET_TAB,
  payload,
});

export const setNavigationError = error => ({
  type: SET_NAVIGATION_ERROR,
  payload: error,
});

export const increaseInContentVideosPresent = () => ({
  type: INC_IN_CONTENT_VIDEOS_PRESENT,
});

export const decreaseInContentVideosPresent = () => ({
  type: DEC_IN_CONTENT_VIDEOS_PRESENT,
});

export const increaseInContentVideosVisible = () => ({
  type: INC_IN_CONTENT_VIDEOS_VISIBLE,
});

export const decreaseInContentVideosVisible = () => ({
  type: DEC_IN_CONTENT_VIDEOS_VISIBLE,
});
